
import React from "react";
import { Check } from "lucide-react";
import image from "../../assets/left.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
const WhyChooseKL = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-[#F5F5F2] mb-12 px-4">
      <div className="max-w-7xl mx-auto">

        {/* TOP HEADING */}
        <h2 className="text-center text-4xl md:text-5xl font-serif text-[#1F2937] mb-14">
          Why Choose Us?
        </h2>

        {/* MAIN CARD */}
        <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.05)] p-6 md:p-10">

          <div className="grid lg:grid-cols-2 gap-12 items-start">

            {/* LEFT CONTENT */}
            <div>

              {/* TAG */}
              <span className="text-xs bg-[#45A30133] text-[#45A301] px-3 py-1 rounded-full">
                KL Property
              </span>

              {/* TITLE */}
              <h3 className="text-3xl md:text-4xl font-serif text-[#1F2937] mt-4 mb-4 leading-snug">
                Why Choose KL Property
              </h3>

              {/* DESCRIPTION */}
              <p className="text-[#6B7280] mb-8 text-sm md:text-base leading-relaxed">
                With a legacy of trust and deep-rooted knowledge of the Kerala terrain,
                we offer more than just land — we offer peace of mind and professional excellence.
              </p>

              {/* FEATURES */}
              <div className="space-y-5">

                {[
                  {
                    title: "30+ Years Background",
                    desc: "A family-run legacy of real estate excellence since 1994.",
                  },
                  {
                    title: "Local Expertise",
                    desc: "Deep understanding of Kerala’s specific land laws and topography.",
                  },
                  {
                    title: "Documentation Support",
                    desc: "End-to-end legal verification and seamless paperwork handling.",
                  },
                  {
                    title: "Genuine Pricing",
                    desc: "Transparent market rates without hidden brokerage or fees.",
                  },
                  {
                    title: "Friendly Guidance",
                    desc: "Personalized consultation to match your vision and budget.",
                  },
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-3">

                    {/* ICON */}
                    <div className="w-6 h-6 min-w-[24px] bg-[#45A30133] rounded-full flex items-center justify-center">
                      <Check size={14} className="text-[#45A301]" />
                    </div>

                    {/* TEXT */}
                    <div>
                      <h4 className="text-sm md:text-base font-semibold text-[#1F2937]">
                        {item.title}
                      </h4>
                      <p className="text-xs md:text-sm text-[#6B7280]">
                        {item.desc}
                      </p>
                    </div>

                  </div>
                ))}

              </div>

              {/* BUTTON */}
              <button onClick={() => navigate("/properties")} className="mt-8 bg-[#45A301] hover:bg-[#3e9202] text-white px-6 md:px-8 py-2.5 rounded-lg flex items-center gap-2 transition">
                Explore Available Properties
                <FaArrowRightLong />
              </button>

            </div>

            {/* RIGHT IMAGE */}
            <div className="flex justify-center lg:justify-end">

              <div className="w-full max-w-[460px]">

                <div className="relative w-full aspect-[4/5] rounded-xl overflow-hidden">

                  <img
                    src={image}
                    alt="Kerala"
                    className="w-full h-full object-cover"
                  />

                  {/* TEXT OVER IMAGE */}
                  {/* <div className="absolute bottom-4 left-4 text-white">
                    <p className="text-sm font-medium">Idukki, Kerala</p>
                    <p className="text-xs opacity-80">God's Own Country</p>
                  </div> */}

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default WhyChooseKL;